module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjE1Ij4KCTxwb2x5Z29uIHBvaW50cz0iMiwxIDIsMTQgMTMsNyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJ3aGl0ZSIvPgoJPHJlY3QgeD0iMTciIHk9IjIiIHdpZHRoPSI0IiBoZWlnaHQ9IjExIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9IndoaXRlIi8+Cgk8cmVjdCB4PSIyNCIgeT0iMiIgd2lkdGg9IjQiIGhlaWdodD0iMTEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/play-pause.svg
// module id = rbs8
// module chunks = 2 3